export function prefersDarkMode() {
    const darkModeMql =
        window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
    return darkModeMql && darkModeMql.matches;
}

export function setTheme(theme: "dark" | "light"): void {
    localStorage.setItem("theme", theme);

    const body = document.querySelector("body");
    if (body) {
        body.setAttribute("data-theme", theme);
    }
}

export function initialiseTheme() {
    const savedTheme = localStorage.getItem("theme") as "dark" | "light";
    if (!savedTheme) {
        if (prefersDarkMode()) {
            setTheme("dark");
        } else {
            setTheme("light");
        }
    } else {
        setTheme(savedTheme);
    }
}
